<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap v-if="selectedTheme">
      <v-flex md12 lg3 class="mt-4">
        <v-card>
          <v-system-bar color="accent" dark window>
            <v-toolbar-title class="ml-4">Выберите тему или настройте свою</v-toolbar-title>
          </v-system-bar>

          <div>
            <v-list style="background: transparent;text-align:left;">
              <v-list-tile v-for="(item, index) in themes" :key="item.id" @click="change(item)">
              <div v-if="item.selected" class="active-circle" :style="{backgroundColor: selectedTheme.themeContent.primary}"></div>
                <v-list-tile-content class="ml-4 dantser-input" @dblclick="isNotEdited(item.id)">                  
                  <v-text-field
                    autofocus
                    v-if="currentId === item.id"
                    clearable
                    v-model="userThemeName"
                    @keyup.enter="saveThemeName"
                    @blur="saveThemeName"
                  ></v-text-field>                  
                  <span v-else :class="[item.selected ? 'primary--text' : '']">{{item.name}}</span>
                </v-list-tile-content>                

                <template v-if="!item.system">
                  <v-list-tile-action class="small-list-action">
                    <v-btn icon @click.stop="editThemeName(item)" small flat>
                      <v-icon color="info">edit</v-icon>
                    </v-btn>
                  </v-list-tile-action>
                  <v-list-tile-action class="small-list-action">
                    <v-btn icon @click.stop="deleteTheme(item.id)" small flat>
                      <v-icon color="secondary">delete</v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </template>
                
              </v-list-tile>

              <v-list-tile
                class="dantser-input"
                style="font-size:11px;font-style:italic;padding-left:10px;color:#6f6e64"
              >
                <v-list-tile-content>
                  <v-text-field
                    autofocus
                    v-if="dialogAdd"
                    @keyup.enter="addUserTheme"
                    v-model="userThemeName"
                    clearable
                    @blur="addUserTheme"
                  ></v-text-field>
                  <span v-else @click="dialogAdd=true" class="pointer ml-5">Создать новую тему</span>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </div>
        </v-card>
      </v-flex>

      <v-flex md12 lg8 class="mt-4" offset-lg1>
        <v-layout wrap style="margin: 0">
          <v-toolbar
            dark
            :color="selectedTheme.themeContent.topPanel"
            class="color-transition justify-center"
            clipped-left
            clipped-right
            dense
            @click="showDialog('topPanel')"
            style="cursor:pointer;"
          >
            <span
              style="width: 100%;text-align: center;font-size: 18px;"
            >Нажми сюда и настрой свой цвет верхней панели</span>
          </v-toolbar>

          <v-toolbar
            :color="selectedTheme.themeContent.panel"
            style="cursor: pointer;"
            dark
            dense
            @click="showDialog('panel')"
          >
            <span
              style="width:100%;text-align: center;font-size: 18px;"
            >Нажми сюда и настрой свой цвет панели приложений</span>
          </v-toolbar>

          <v-navigation-drawer
            left
            clipped
            width="300"
            style="overflow: auto; height: auto;"
            z-index="1"
            mobile-break-point
          >
          <v-flex style="width: 100%;text-align: center;">Выберите цвет активных иконок</v-flex>
          <v-list style="height: auto;" two-line dense>
              <v-list-tile class="pl-5 pointer">
                <v-list-tile-action>
                  <v-icon
                    size="32"
                    :color="selectedTheme.themeContent.primary"
                    @click="showDialog('primary')"
                  >mdi-account</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title
                    @click="showDialog('primary')"
                    class="primary--text"
                  >Профиль</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
            <v-flex style="width: 100%;text-align: center;">Настройте цвет иконок</v-flex>
            
            <v-list style="height: auto;" two-line dense>
              <v-list-tile v-for="(item, index) in navItems" :key="index" class="pl-5 pointer">
                <v-list-tile-action>
                  <v-icon
                    size="32"
                    :color="selectedTheme.themeContent.iconColor"
                    @click="showDialog('iconColor')"
                  >{{ item.icon }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title
                    @click="showDialog('iconColor')"
                    class="iconColor--text"
                  >{{item.text}}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>              
            </v-list>
          </v-navigation-drawer>            
              
          <v-layout>
          <v-flex xs12 class="pa-3">
            <div @click="showDialog('accent')">
                <v-system-bar
                  style="cursor: pointer;"
                  :color="selectedTheme.themeContent.accent"
                  dark
                  window                
                >
                  <v-toolbar-title class="ml-4">Выберите цвет шапок блоков приложений</v-toolbar-title>
                </v-system-bar>
                </div>
              <v-flex xs12>
                <v-layout row justify-center class="ma-2">Выберите цвет кнопок</v-layout>
                <v-layout justify-center>
                  <v-btn
                    :color="selectedTheme.themeContent.success"
                    @click="showDialog('success')"
                    dark
                  >Сохранить</v-btn>
                  <v-btn
                    :color="selectedTheme.themeContent.error"
                    @click="showDialog('error')"
                    dark
                  >Отмена</v-btn>
                  
                  <v-btn
                    :color="selectedTheme.themeContent.secondary"
                    @click="showDialog('secondary')"
                    dark
                  >Кнопка</v-btn>
                </v-layout>
                <v-layout row class="pt-5">
                  <v-flex>
                    <v-alert
                      style="cursor: pointer;"
                      type="info"
                      :value="true"
                      :color="selectedTheme.themeContent.info"
                      @click="showDialog('info')"
                      dark
                    >Выберите цвет информационных сообщений</v-alert>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex>
                    <v-alert
                      style="cursor: pointer;"
                      type="warning"
                      :value="true"
                      :color="selectedTheme.themeContent.warning"
                      @click="showDialog('warning')"
                      dark
                    >Выберите цвет предупреждающих сообщений</v-alert>
                  </v-flex>
                </v-layout>
              </v-flex>
          </v-flex> 
        </v-layout>       
        </v-layout>
        <v-dialog v-model="dialog" max-width="520px" persistent>
          <photoshop-picker
            head="Выбор цвета"
            cancelLabel="Отмена"
            newLabel="Текущий"
            currentLabel="Другой"
            v-model="colors"
            @ok="setColor"
            @cancel = "dialog=false"
            style="width: auto; height: auto;"
          ></photoshop-picker>
        </v-dialog>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { Photoshop } from "vue-color";
import { mapGetters } from "vuex";

export default {
  name: "Colors",

  data() {
    return {
      navItems: [
        {
          icon: "mdi mdi-account-multiple-outline",
          text: "Оргструктура"
        },
        {
          icon: "mdi mdi-cloud-upload",
          text: "Диск"
        },
        {
          icon: "mdi mdi-silverware",
          text: "Каталог БП"
        }
      ],
      dialog: false,
      dialogAdd: false,
      dialogName: "",
      currentId: null,
      themeName: '',
      colors:  "#0288d1",
      userThemeName: "",
      newTheme: {},
      possible: "abcdefghijklmnopqrstuvwxyz",
      newUserTheme: {},
      nameCounter: 0,
      
    };
  },
  components: {
    'photoshop-picker': Photoshop
  },
  computed: {
    ...mapGetters("app/account", ["themes", "selectedTheme"])
  },
  
  methods: {
    setColor(color) {
      if (this.selectedTheme.system) {
        let newTheme = JSON.parse(JSON.stringify(this.selectedTheme));
        newTheme.system = false;
        newTheme.selected = true;
        newTheme.name = "Моя";
        newTheme.themeContent[this.dialogName] = this.colors.hex;
        this.$store.dispatch('app/account/addTheme', newTheme).then( theme => {
          this.$store.dispatch('app/account/selectTheme', theme.id)
        })
      } else {
        this.$store.dispatch('app/account/saveTheme', {id: this.selectedTheme.id, themeContent: {[this.dialogName]: this.colors.hex} })
        this.$vuetify.theme = this.selectedTheme.themeContent
      }
      this.dialog = false;
    },
    
    showDialog(colorName) {
      this.dialog = true
      this.dialogName = colorName
      this.colors = this.selectedTheme.themeContent[colorName]
    },
    
    change(theme) {
      if(theme.id!==this.selectedTheme.id){
        this.$store.dispatch('app/account/selectTheme', theme.id)
      }
    },
    
    addUserTheme() {
      if (this.userThemeName.length < 1) {
        this.dialogAdd = false
      } else {
        let newTheme = JSON.parse(JSON.stringify(this.selectedTheme))
        newTheme.system = false
        newTheme.selected = false
        newTheme.name = this.userThemeName
        this.$store.dispatch('app/account/addTheme', newTheme)
        this.dialogAdd = false
      }
      this.userThemeName = ""
    },
    
    editThemeName(theme){
      this.currentId = theme.id
      this.userThemeName = theme.name
    },
    
    saveThemeName() {
      let id = this.currentId
      let name = this.userThemeName
      this.$store.dispatch('app/account/saveTheme', {id, name})
      this.currentId = null
      this.userThemeName = ""
    },
    
    deleteTheme(id) {
      this.$store.dispatch('app/account/deleteTheme', id)
    },
  }
};
</script>


<style lang="scss">
.color-transition {
  transition: color 0.3s ease;
}
.small-list-action {
  min-width: 31px;
}
.dantser-input .v-input {
  width: 100%;
}
.action-icon {
  min-width: 42px;
}
.action-icon i {
  color: inherit;
}
.calculated-width {
  width: calc(100% - 16px);
}
.active-circle {
  width: 10px;
  height: 10px;
  border-radius: 50%;  
}
</style>


// WEBPACK FOOTER //
// src/apps/account/components/Account/Colors.vue